import httpClient from '@/api/http-client'

const urlPrefix = '/bpm/v1/kanban'

export default {

  /**
   * Получение списка карточек.
   *
   * @param {String} boardId
   * @returns {*}
   */
  list( boardId ) {

    return httpClient.http
      .get( `${urlPrefix}/boards/${boardId}/cards` )
      .then( response => {
        return response.data
      })
  },

  /**
   * Получение карточки.
   *
   * @param {String} boardId
   * @param {String} id
   * @returns {*}
   */
  item( boardId, id ) {

    return httpClient.http
      .get( `${urlPrefix}/boards/${boardId}/cards/${id}` )
      .then( response => {
        return response.data
      } )
  },

  /**
   * Поиск карточки по процессу.
   *
   * @param {String} id
   * @returns {*}
   */
  find( id ) {

    return httpClient.http
      .get( `${urlPrefix}/processes/${id}` )
      .then( response => {
        return response.data
      } )
  },

  /**
   * Создание карточки.
   *
   * @param {String} boardId
   * @param {Object} data
   * @returns {*}
   */
  create( boardId, data ) {

    return httpClient.http
      .put( `${urlPrefix}/boards/${boardId}/cards`, data )
      .then( response => {
        return response.data
      } )
  },

  /**
   * Обновление карточки.
   *
   * @param {String} boardId
   * @param {Object} data
   * @returns {Promise<T>}
   */
  update( boardId, data ) {

    const { id } = data

    return httpClient.http
      .patch( `${urlPrefix}/boards/${boardId}/cards/${id}`, data )
      .then( response => {
        return response.data
      } )
  },

  /**
   * Удаление карточки.
   *
   * @param {String} boardId
   * @param {String} id
   * @returns {*}
   */
  delete( boardId, id ) {

    return httpClient.http
      .delete( `${urlPrefix}/boards/${boardId}/cards/${id}` )
      .then( response => {
        return response.data
      } )
  }
}



// WEBPACK FOOTER //
// ./src/apps/bpm/kanban/api/card/api.js